import React, {PureComponent} from 'react'
import {withStyles} from '@material-ui/core/styles/index';
import { Typography, Grid } from '@material-ui/core';

const styles = theme => ({
    root: {
        margin: theme.spacing(2),
    },
    gaugeTitle: {
        textAlign: 'center',
        marginTop: theme.spacing(1),
    },
});


class Scoring extends PureComponent {
    render() {
        const {classes, first, second, third} = this.props;

        return (
            <div className={classes.root}>
                <Grid container alignItems="center">
                    {first &&
                    <Grid item xs={second ? 6 : 12} md={second ? 6 : 12} gutterBottom
                          style={{padding: '8px 8px 0 8px'}}>
                        <div className={'c100 p' + first.value + ' center ' + first.color}>
                            <span>{first.label}</span>
                            <div className="slice">
                                <div className="bar"></div>
                                <div className="fill"></div>
                            </div>
                        </div>
                        <Typography gutterBottom variant="body1" className={classes.gaugeTitle}>
                            {first.title}
                        </Typography>
                    </Grid>}
                    {second &&
                    <Grid item xs={6} md={6} gutterBottom style={{padding: '8px 8px 0 8px'}}>
                        <div className={'c100 p' + second.value + ' center ' + second.color}>
                            <span>{second.label}</span>
                            <div className="slice">
                                <div className="bar"></div>
                                <div className="fill"></div>
                            </div>
                        </div>
                        <Typography gutterBottom variant="body1" className={classes.gaugeTitle}>
                            {second.title}
                        </Typography>
                    </Grid>}
                    {third && <Grid item xs={12} md={4} gutterBottom style={{padding: '8px 8px 0 8px'}}>
                        <div className={'c100 p' + third.value + ' center ' + third.color}>
                            <span>{second.label}</span>
                            <div className="slice">
                                <div className="bar"></div>
                                <div className="fill"></div>
                            </div>
                        </div>
                        <Typography gutterBottom variant="body1" className={classes.gaugeTitle}>
                            {second.title}
                        </Typography>
                    </Grid>}
                </Grid>
            </div>
        )
    }
}


export default withStyles(styles)(Scoring);
